export default {
  translation: {
    common: {
      accept: 'Accepter',
      alreadyUser: 'Allerede bruger?',
      and: 'og',
      backToLogin: 'Tilbage til login-side',
      continueWith: 'Fortsæt med {{provider}}',
      coreNotFound: 'Kunne ikke hente kerneindstillinger',
      createAccount: 'Opret en konto',
      createYourAccount: 'Opret din konto',
      emailOrUsername: 'E-mail eller brugernavn',
      invalidUsernameOrPassword: 'Ugyldigt brugernavn eller adgangskode',
      localRegistrationDisabled: 'Lokal brugerregistrering er deaktiveret af administrator',
      login: 'Log ind',
      logInToBoards: 'Log ind',
      newToBoards: 'Ny i 4ga Boards?',
      noInternetConnection: 'Ingen internetforbindelse',
      pageNotFound_title: 'Siden blev ikke fundet',
      password: 'Adgangskode',
      policyNotAccepted: 'Accepter venligst vilkår og privatlivspolitik',
      privacyPolicy: 'Privatlivspolitik',
      register: 'Registrer',
      registerWithGoogle: 'Registrer med Google',
      registrationDisabled: 'Brugerregistrering er deaktiveret af administrator',
      serverConnectionFailed: 'Forbindelse til server mislykkedes',
      ssoRegistrationDisabled: 'SSO-registrering er deaktiveret af administrator',
      termsOfService: 'Vilkår for brug',
      togglePasswordVisibility: 'Vis/skjul adgangskode',
      unknownError: 'Ukendt fejl, prøv igen senere',
    },

    action: {
      logIn: 'Log ind',
    },
  },
};
